import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/survey/Home.vue';
import SurveyQ1 from '@/views/survey/SurveyQ1.vue';
import SurveyQ2 from '@/views/survey/SurveyQ2.vue';
import SurveyQ3 from '@/views/survey/SurveyQ3.vue';
import SurveyQ4SSComment from '@/views/survey/SurveyQ4SSComment.vue';
import SurveyQ4 from '@/views/survey/SurveyQ4.vue';
import SurveyFaq from '@/views/survey/SurveyQ5Faq.vue';
import SurveyQ51 from '@/views/survey/SurveyQ51.vue';
import SurveyQ52 from '@/views/survey/SurveyQ52.vue';
import SurveyQ6SSRating from '@/views/survey/SurveyQ6SSRating.vue';
import SurveyQ6 from '@/views/survey/SurveyQ6.vue';
import SurveyQ71 from '@/views/survey/SurveyQ71.vue';
import SurveyQ72 from '@/views/survey/SurveyQ72.vue';
import SurveyQ8 from '@/views/survey/SurveyQ8.vue';
import SurveyQ9 from '@/views/survey/SurveyQ9.vue';
import CallEnd from '@/views/survey/CallEnd.vue';
import InteractiveHome from '@/views/interactive/InteractiveHome.vue';
import Eula from '@/views/Eula.vue';
import FirstNotification from '@/views/recommendation/FirstNotification.vue';
import GalaxyMain from '@/views/recommendation/GalaxyMain.vue';
import AndroidMain from '@/views/recommendation/AndroidMain.vue';
import IosMain from '@/views/recommendation/IosMain.vue';
import XperiaMain from '@/views/recommendation/XperiaMain.vue';
import newDay2Content from '@/views/recommendation/newDay2Content.vue';
import ThirdNotification from '@/views/recommendation/ThirdNotification.vue';
import Recommendation from '@/views/recommendation/Recommendation.vue';
import Setting from '@/views/interactive/Setting.vue';
import SurveyQ10EnqRating from '@/views/survey/SurveyQ10EnqRating.vue';
import SurveyQ11OptrRating from '@/views/survey/SurveyQ11OptrRating.vue';
import SurveyQ18 from '@/views/survey/SurveyQ18.vue';
import SurveyQ19 from '@/views/survey/SurveyQ19.vue';
import SurveyQ20 from '@/views/survey/SurveyQ20.vue';

const routes: any = [
  {
    path: '/.well-known'
  },
  {
    path: '/survey/',
    name: 'Home',
    component: Home
  },
  {
    path: '/survey/question1/',
    name: 'Question1',
    component: SurveyQ1
  },
  {
    path: '/survey/question2/',
    name: 'Question2',
    component: SurveyQ2
  },
  {
    path: '/survey/question3/',
    name: 'Question3',
    component: SurveyQ3
  },
  {
    path: '/survey/question4/',
    name: 'Question4',
    component: SurveyQ4
  },
  {
    path: '/survey/question4SSC/',
    name: 'Question4SSC',
    component: SurveyQ4SSComment
  },
  {
    path: '/survey/question5Faq/',
    name: 'SurveyFAQ',
    component: SurveyFaq
  },
  {
    path: '/survey/question6SSRating/',
    name: 'SurveyQ6SSRating',
    component: SurveyQ6SSRating
  },
  {
    path: '/survey/question51/',
    name: 'Question51',
    component: SurveyQ51
  },
  {
    path: '/survey/question52/',
    name: 'Question52',
    component: SurveyQ52
  },
  {
    path: '/survey/question6/',
    name: 'Question6',
    component: SurveyQ6
  },
  {
    path: '/survey/question71/',
    name: 'Question71',
    component: SurveyQ71
  },
  {
    path: '/survey/question72/',
    name: 'Question72',
    component: SurveyQ72
  },
  {
    path: '/survey/question8/',
    name: 'Question8',
    component: SurveyQ8
  },
  {
    path: '/survey/question9/',
    name: 'Question9',
    component: SurveyQ9
  },
  {
    path: '/survey/question10EnqRating/',
    name: 'Question10EnqRating',
    component: SurveyQ10EnqRating
  },
  {
    path: '/survey/question11OptrRating/',
    name: 'Question11OptrRating',
    component: SurveyQ11OptrRating
  },
  {
    path: '/survey/question18/',
    name: 'Question18',
    component: SurveyQ18
  },
  {
    path: '/survey/question19/',
    name: 'Question19',
    component: SurveyQ19
  },
  {
    path: '/survey/question20/',
    name: 'Question20',
    component: SurveyQ20
  },
  {
    path: '/survey/end/',
    name: 'CallEnd',
    component: CallEnd
  },
  {
    path: '/interactive/rule-of-third',
    component: InteractiveHome,
    children: [
      {
        path: 'level',
        name: 'level',
        component: () => import('../views/interactive/Level.vue')
      },
      {
        path: 'answer',
        name: 'levelAnswer',
        component: () => import('../views/interactive/LevelAnswer.vue')
      },
      {
        path: 'clear',
        name: 'levelClear',
        component: () => import('../views/interactive/LevelClear.vue')
      },
      {
        path: 'setting',
        name: 'Setting',
        component: Setting
      }
    ]
  },
  {
    path: '/eula',
    name: 'Eula',
    component: Eula
  },
  {
    path: '/timeline/recommendation',
    name: 'Recommendation',
    component: Recommendation,
    children: [
      {
        path: '0001',
        name: 'GalaxyMain',
        component: GalaxyMain
      },
      {
        path: '0001-sub2',
        name: 'GalaxySecondNotification',
        component: () => import('../views/recommendation/GalaxySecondNotification.vue')
      },
      {
        path: '0002',
        name: 'AndroidMain',
        component: AndroidMain
      },
      {
        path: '0002-sub2',
        name: 'AndroidSecondNotification',
        component: () => import('../views/recommendation/AndroidSecondNotification.vue')
      },
      {
        path: '0003',
        name: 'IosMain',
        component: IosMain
      },
      {
        path: '0003-sub2',
        name: 'IosSecondNotification',
        component: () => import('../views/recommendation/IosSecondNotification.vue')
      },
      {
        path: '0004',
        name: 'XperiaMain',
        component: XperiaMain
      },
      {
        path: '0004-sub2',
        name: 'XperiaSecondNotification',
        component: () => import('../views/recommendation/XperiaSecondNotification.vue')
      },
      {
        path: '0001-sub1',
        name: 'FirstNotification',
        component: FirstNotification
      },
      {
        path: '0001-sub3',
        name: 'ThirdNotification',
        component: ThirdNotification
      },
      {
        path: 'RofT',
        name: 'RofT',
        component: newDay2Content
      }
    ]
  },
  {
    path: '/download',
    name: 'RouterPage',
    component: () => import('../views/RouterPage.vue')
  },
  {
    path: '/sessionSummary',
    name: 'Session',
    component: () => import('../views/Session.vue')
  },
  {
    path: '/au',
    alias: ['/uq'],
    name: 'Base',
    component: () => import('../views/Base.vue'),
    children: [
      {
        path: 'eula',
        name: 'eula',
        component: () => import('../views/Eula.vue')
      },
      {
        path: 'privacy-policy/android',
        name: 'AndroidPrivacyPolicy',
        component: () => import('../views/privacy-policy/Android.vue')
      },
      {
        path: 'privacy-policy/ios',
        name: 'IosPrivacyPolicy',
        component: () => import('../views/privacy-policy/Ios.vue')
      },
      {
        path: 'privacy-policy/ios-details',
        name: 'IosDetails',
        component: () => import('../views/privacy-policy/IosDetails.vue')
      },
      {
        path: 'privacy-policy/android-details',
        name: 'AndroidDetails',
        component: () => import('../views/privacy-policy/AndroidDetails.vue')
      }
    ]
  },
  {
    path: '/l/:page?',
    name: 'launch',
    component: () => import('../views/Launch.vue'),
    props: true
  },
  {
    path: '/ivr/launch',
    name: 'ivr-launch',
    component: () => import('../views/ivr/Launch.vue')
  }
  // {
  //   path: '/ivr',
  //   component: () => import('../views/ivr/Main.vue'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'home',
  //       component: () => import('../views/ivr/Home.vue')
  //     },
  //     {
  //       path: 'home',
  //       name: 'home',
  //       component: () => import('../views/ivr/Home.vue')
  //     },
  //     {
  //       path: 'contact',
  //       name: 'contact',
  //       component: () => import('../views/ivr/Contact.vue')
  //     },
  //     {
  //       path: 'kosapo',
  //       name: 'kosapo',
  //       component: () => import('../views/ivr/Kosapo.vue')
  //     },
  //     {
  //       path: 'content',
  //       name: 'content',
  //       component: () => import('../views/ivr/Content.vue')
  //     },
  //     {
  //       path: 'troubleshooting/:categoryId',
  //       name: 'troubleshooting',
  //       component: () => import('../views/ivr/Troubleshooting.vue')
  //     },
  //     {
  //       path: 'content/:contentId',
  //       name: 'content',
  //       component: () => import('../views/ivr/Content.vue')
  //     },
  //     {
  //       path: 'maintenance',
  //       name: 'maintenance',
  //       component: () => import('../views/ivr/Maintenance.vue')
  //     },
  //     {
  //       path: 'site-policy',
  //       name: 'site policy',
  //       component: () => import('../views/ivr/SitePolicy.vue')
  //     },
  //     {
  //       path: 'privacy-policy',
  //       name: 'privacy policy',
  //       component: () => import('../views/ivr/PrivacyPolicy.vue')
  //     },
  //     {
  //       path: '/ivr/404',
  //       name: 'notFound',
  //       component: () => import('../views/ivr/Error404.vue')
  //     },
  //     {
  //       path: '/ivr/launch',
  //       name: 'ivr-launch',
  //       component: () => import('../views/ivr/Launch.vue')
  //     },
  //     {
  //       path: '/ivr/app-launch',
  //       name: 'ivr-app-launch',
  //       component: () => import('../views/ivr/AppLaunch.vue')
  //     },
  //     {
  //       path: '/ivr/*',
  //       beforeEnter: (to, from, next) => { next('/ivr/404'); }
  //     }
  //   ]
  // }
];

const router = createRouter({
  routes,
  history: createWebHistory()
});

export default router;
